import type { GroupMember, MessageDiscussion } from "@/types";
import { createStore } from "zustand";

interface MessageSearch {
	search: string;
	[key: string]: any;
}

export interface MessageStoreState {
	message?: MessageDiscussion | null;
	members?: GroupMember[];
	module: "cases" | "chats" | null;
	channelType: "group" | "direct" | null;
	channelName: string | null;
	search: MessageSearch | null;
	shouldStickToBottom?: boolean;
	isPrepend?: boolean;
	isReadonly?: boolean;
	isViewOnly?: boolean;
}

interface MessageStoreActions {
	setMessage: (message: MessageStoreState["message"]) => void;
	setModule: (module: "cases" | "chats") => void;
	setChannelType: (channelType: "group" | "direct") => void;
	setChannelName: (channelName: string) => void;
	setSearch: (search: MessageSearch) => void;
	setShouldStickToBottom: (shouldStickToBottom: boolean) => void;
	setIsPrepend: (isPrepend: boolean) => void;
}

export type MessageState = MessageStoreState & MessageStoreActions;

const initialState: MessageStoreState = {
	message: null,
	module: null,
	channelType: null,
	channelName: null,
	search: null,
	shouldStickToBottom: true,
	isPrepend: false,
	isReadonly: false,
	isViewOnly: false,
	members: [],
};

export const createMessageStore = (initProps?: Partial<MessageStoreState>) => {
	return createStore<MessageState>()((set) => ({
		...initialState,
		...initProps,
		setMessage: (message) => set({ message }),
		setModule: (module) => set({ module }),
		setChannelType: (channelType) => set({ channelType }),
		setChannelName: (channelName) => set({ channelName }),
		setSearch: (search) => set({ search }),
		setShouldStickToBottom: (shouldStickToBottom) =>
			set({ shouldStickToBottom }),
		setIsPrepend: (isPrepend) => set({ isPrepend }),
	}));
};

export type MessageStore = ReturnType<typeof createMessageStore>;
